import {
    SCAN_PACKED_INPUT,
    SCAN_SCANNED_INPUT,
    GET_DASHBOARD_INFO,
    STORE_DASHBOARD_INFO,
    STORE_SCAN_RESPONSE,
    CLEAR_SCAN_RESPONSE,
    STORE_PACKED_RESPONSE,
    CLEAR_PACKED_RESPONSE,
    STORE_SCANNED_BARCODES,
    UPDATE_SCANNED_BARCODE,
    STORE_PACKED_BARCODES,
    UPDATE_PACKED_BARCODE,
    STORE_PENDING_PACKED_BARCODES,
    UPDATE_PENDING_PACKED_BARCODE,
    STORE_TOTAL_BARCODES,
    MANUAL_PACK,
    SET_REFRESH,
    DASHBOARD_REFRESH,
    MANUAL_CANCEL,
    MANUAL_VOID,
    FIND_RECENT_LIMBO_SHIPMENTS,
    STORE_LIMBO_SHIPMENTS,
    MANUAL_RESOLVE_LIMBO_SHIPMENT,
    HANDLE_RESOLVED_SHIPMENT,
    CLEAR_RESOLVE_LIMBO_SHIPMENT_RESPONSE_MESSAGE,
    LIST_SHIPPED_SHIPMENT_IN_QUEUE,
    UPDATE_SHIPPED_SHIPMENT_IN_QUEUE,
    MANUAL_CONFIRM_SHIPPED_SHIPMENT,
    RESOLVE_SHIPPED_SHIPMENT,
    FETCH_SHIPPED_SHIPMENT,
    ADD_SHIPPED_SHIPMENT_TO_QUEUE,
    STORE_SHIPPED_SHIPMENT_QUEUE, SET_IMPORT_LOADING, IMPORT_SHIPPED_SHIPMENT_TO_QUEUE
} from '../../constants/dashboard';

export const getDashboardInfo = (company, date, shipAddressId) => ({
    type: GET_DASHBOARD_INFO,
    company,
    date,
    shipAddressId
});

export const findRecentLimboShipments = (locationId) => ({
    type: FIND_RECENT_LIMBO_SHIPMENTS,
    locationId
});

export const manualResolveLimboShipment = (shipmentId) => ({
    type: MANUAL_RESOLVE_LIMBO_SHIPMENT,
    shipmentId
});

export const scanScannedInput = (scan) => ({
    type: SCAN_SCANNED_INPUT,
    scan,
});

export const scanPackedInput = (packed) => ({
    type: SCAN_PACKED_INPUT,
    packed,
});

export const storeDashboardInfo = (dashboard) => ({
    type: STORE_DASHBOARD_INFO,
    dashboard,
});

export const storeScanResponse = (scanResponse) => ({
    type: STORE_SCAN_RESPONSE,
    scanResponse,
});

export const clearScanResponse = () => ({
    type: CLEAR_SCAN_RESPONSE,
});

export const storePackedResponse = (packedResponse) => ({
    type: STORE_PACKED_RESPONSE,
    packedResponse,
});

export const storeLimboShipments = (limboShipments) => ({
    type: STORE_LIMBO_SHIPMENTS,
    limboShipments
})

export const handleResolvedShipment = (shipmentId, message, shipment) => ({
    type: HANDLE_RESOLVED_SHIPMENT,
    shipmentId,
    message,
    shipment,
})

export const clearResolveLimboShipmentResponseMessage = () => ({
    type: CLEAR_RESOLVE_LIMBO_SHIPMENT_RESPONSE_MESSAGE
})

export const clearPackedResponse = () => ({
    type: CLEAR_PACKED_RESPONSE
});

export const manualVoid = (trackingNumber, comment, reason) => ({
    type: MANUAL_VOID,
    trackingNumber,
    comment,
    reason
})

export const manualPack = (trackingNumber) => ({
    type: MANUAL_PACK,
    trackingNumber
})

export const storeScannedBarcodes = (barcodes) => ({
    type: STORE_SCANNED_BARCODES,
    barcodes
})

export const updateScannedBarcodes = (label) => ({
    type: UPDATE_SCANNED_BARCODE,
    label
})

export const storePackedBarcodes = (barcodes) => ({
    type: STORE_PACKED_BARCODES,
    barcodes
})

export const updatePackedBarcodes = (label) => ({
    type: UPDATE_PACKED_BARCODE,
    label
})

export const storePendingPackedBarcodes = (barcodes) => ({
    type: STORE_PENDING_PACKED_BARCODES,
    barcodes
})

export const updatePendingPackedBarcodes = (label) => ({
    type: UPDATE_PENDING_PACKED_BARCODE,
    label
})

export const storeTotalBarcodes = (barcodes) => ({
    type: STORE_TOTAL_BARCODES,
    barcodes
})

export const setRefresh = (refreshing) => ({
    type: SET_REFRESH,
    refreshing
})

export const refreshDashboard = (needsRefresh) => ({
    type: DASHBOARD_REFRESH,
    needsRefresh
})

export const listShippedShipmentInQueue = (data) => ({
    type: LIST_SHIPPED_SHIPMENT_IN_QUEUE,
    data
})

export const fetchShippedShipment = (data,callback) => ({
    type: FETCH_SHIPPED_SHIPMENT,
    data,
    callback
})

export const addShippedShipmentToQueue = (data) => ({
    type: ADD_SHIPPED_SHIPMENT_TO_QUEUE,
    data
})


export const updateShippedShipmentInQueue = (data) => ({
    type: UPDATE_SHIPPED_SHIPMENT_IN_QUEUE,
    data
})

export const manualConfirmShippedShipment = (data) => ({
    type: MANUAL_CONFIRM_SHIPPED_SHIPMENT,
    data
})

export const resolveShippedShipment = (data, callback) => ({
    type: RESOLVE_SHIPPED_SHIPMENT,
    data,
    callback
})

export const storeShippedShipmentInQueue = (data) => ({
    type: STORE_SHIPPED_SHIPMENT_QUEUE,
    data
})

export const importShippedShipmentToQueue = (data,callback) => ({
    type: IMPORT_SHIPPED_SHIPMENT_TO_QUEUE,
    data,
    callback
})


export const setImportLoading = (loading) => ({
    type: SET_IMPORT_LOADING,
    loading
})
